<template>
  <div class="LmSearch relative leading-zero">
    <lm-icon-button v-if="!alwaysOpened" icon="search" @click.prevent="open" />
    <transition name="search-transition">
      <div
        v-show="show || alwaysOpened"
        class="flex items-center h-10 pl-3 pr-2 bg-white border"
        :class="{SearchContainer: !alwaysOpened}"
      >
        <input
          ref="SearchInput"
          class="mr-2 text-gray-700 text-s leading-normal focus:outline-none"
          :class="compact ? 'w-40' : 'w-40 desktop:w-56'"
          :value="value"
          :placeholder="placeholder"
          @input="$emit('input', $event.target.value)"
        />
        <lm-icon-button
          :icon="value === '' && !show ? 'search' : 'close'"
          svg
          @click="close"
        />
      </div>
    </transition>
  </div>
</template>

<script>
import LmIconButton from '@/components/ui/LmIconButton'

export default {
  name: 'LmSearch',
  components: {LmIconButton},
  props: {
    alwaysOpened: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Search'
    },
    value: {
      type: String,
      default: null
    },
    compact: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: false
    }
  },
  methods: {
    open() {
      this.show = true
      this.$nextTick(() => {
        this.$refs.SearchInput.focus()
      })
    },
    close() {
      this.show = false
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.SearchContainer {
  @apply absolute top-0 right-0 -mt-2 -mr-2;
  transform-origin: 90%;
}
/* Transitions */
.search-transition-enter-active,
.search-transition-leave-active {
  transition: transform 0.2s, opacity 0.2s;
}
.search-transition-enter,
.search-transition-leave-to {
  opacity: 0;
  transform: scaleX(0.6);
}
</style>
